var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "col content-spacing", attrs: { role: "main" } },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-content" },
        [
          _c("b-table", {
            attrs: {
              striped: "",
              hover: "",
              items: _vm.items,
              fields: _vm.fields
            },
            scopedSlots: _vm._u([
              {
                key: "cell(totalAmountDistributor)",
                fn: function(data) {
                  return [
                    _c("span", [
                      _vm._v(
                        "R$ " +
                          _vm._s(
                            _vm.formatCurrency(data.item.totalAmountDistributor)
                          )
                      )
                    ])
                  ]
                }
              },
              {
                key: "cell(totalCredit)",
                fn: function(data) {
                  return [
                    _c("span", [
                      _vm._v(
                        "R$ " +
                          _vm._s(_vm.formatCurrency(data.item.totalCredit))
                      )
                    ])
                  ]
                }
              },
              {
                key: "cell(economy)",
                fn: function(data) {
                  return [
                    _c("span", [
                      _vm._v(
                        "R$ " + _vm._s(_vm.formatCurrency(data.item.economy))
                      )
                    ])
                  ]
                }
              },
              {
                key: "cell(ticketVeins)",
                fn: function(data) {
                  return [
                    _c("span", [
                      _vm._v(
                        "R$ " +
                          _vm._s(_vm.formatCurrency(data.item.ticketVeins))
                      )
                    ])
                  ]
                }
              },
              {
                key: "cell(moneyTransferPlant)",
                fn: function(data) {
                  return [
                    _c("span", [
                      _vm._v(
                        "R$ " +
                          _vm._s(
                            _vm.formatCurrency(data.item.moneyTransferPlant)
                          )
                      )
                    ])
                  ]
                }
              },
              {
                key: "cell(moneyGrossRevenueVeins)",
                fn: function(data) {
                  return [
                    _c("span", [
                      _vm._v(
                        "R$ " +
                          _vm._s(
                            _vm.formatCurrency(data.item.moneyGrossRevenueVeins)
                          )
                      )
                    ])
                  ]
                }
              },
              {
                key: "cell(percentGrossRevenueVeins)",
                fn: function(data) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(data.item.percentGrossRevenueVeins.toFixed(2))
                      )
                    ])
                  ]
                }
              },
              {
                key: "cell(energyTariff)",
                fn: function(data) {
                  return [
                    _c("span", [
                      _vm._v(
                        "R$ " +
                          _vm._s(_vm.formatCurrency(data.item.energyTariff))
                      )
                    ])
                  ]
                }
              },
              {
                key: "cell(injectedRate)",
                fn: function(data) {
                  return [
                    _c("span", [
                      _vm._v(
                        "R$ " +
                          _vm._s(_vm.formatCurrency(data.item.injectedRate))
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
      },
      [
        _c("h1", { staticClass: "h2" }, [_vm._v("Calculos")]),
        _vm._v(" "),
        _c("div", { staticClass: "btn-toolbar mb-2 mb-md-0" }, [
          _c("div", { staticClass: "btn-group mr-2" })
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }